import {envVars} from '@/envVars.ts'
import {io} from 'socket.io-client'

export const socket = io(`${envVars.VITE_WS_ENDPOINT}`, {
    transports: ['websocket']
})
